var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerBodyWax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    className: "service-svgs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    strokeWidth: 1,
    "connector-curvature": 0,
    d: "M14.443,25.709c-0.828,1.395-1.715,2.756-2.654,4.08  c-0.16,0.225-0.473,0.275-0.697,0.115c-0.223-0.16-0.275-0.47-0.117-0.693c1.178-1.662,2.271-3.383,3.271-5.156  C14.303,24.607,14.369,25.158,14.443,25.709z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M13.396,18.278c-0.234-0.276-0.461-0.559-0.682-0.847  c-2.035,3.766-3.564,7.786-4.543,11.954c-0.061,0.27,0.109,0.536,0.379,0.597c0.266,0.061,0.529-0.104,0.596-0.368  C10.072,25.67,11.5,21.859,13.396,18.278L13.396,18.278z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    strokeWidth: 1,
    "connector-curvature": 0,
    d: "M20.742,13.977c0.783-1.451,1.381-2.996,1.775-4.598  c0.549-2.224,0.398-4.563-0.428-6.698c-0.102-0.258,0.027-0.548,0.285-0.647s0.547,0.028,0.646,0.286l0,0  c0.902,2.327,1.064,4.876,0.467,7.299c-0.502,2.04-1.316,3.989-2.412,5.781C20.967,14.925,20.855,14.45,20.742,13.977L20.742,13.977  z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    strokeWidth: 1,
    "connector-curvature": 0,
    d: "M15.469,17.602c-2.18-2.355-3.727-5.227-4.496-8.342  c-0.539-2.186-0.371-4.486,0.479-6.571c0.102-0.257-0.025-0.548-0.281-0.648c-0.254-0.1-0.539,0.021-0.645,0.271  c-0.93,2.28-1.113,4.796-0.523,7.188c0.809,3.28,2.438,6.302,4.732,8.782c0.164,0.178,0.256,0.41,0.256,0.652  c-0.008,3.592,0.385,7.172,1.172,10.676c0.061,0.27,0.328,0.439,0.598,0.379s0.438-0.328,0.377-0.598  c-0.77-3.432-1.154-6.938-1.146-10.455C15.99,18.441,15.805,17.965,15.469,17.602L15.469,17.602z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M20.371,17.282c0.164,4.116-0.096,8.237-0.773,12.3  c-0.049,0.271-0.309,0.453-0.58,0.404c-0.268-0.047-0.449-0.3-0.406-0.568c0.668-3.996,0.922-8.049,0.762-12.096  c-0.014-0.325-0.057-0.648-0.129-0.965c-0.885-3.862-1.867-7.701-2.945-11.515c-0.072-0.267,0.084-0.542,0.35-0.615  c0.264-0.073,0.537,0.079,0.613,0.343c1.082,3.829,2.068,7.686,2.957,11.563C20.305,16.512,20.357,16.896,20.371,17.282  L20.371,17.282z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerBodyWax);
export default __webpack_public_path__ + "static/media/lowerBodyWax.260ec95c4519b886c4c3c6519cf67c1a.svg";
export { ForwardRef as ReactComponent };